import { useApi } from "@/lib/useApi";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { PageHeader, EmptyState } from "@/components/common";
import { fDateTime } from "@/lib/format";
import { ScrollText } from "lucide-react";

export default function Audit() {
  const { data, loading } = useApi("/audit");
  if (loading) return <p className="text-muted-foreground">Laddar auditlogg…</p>;
  return (
    <div>
      <PageHeader title="Auditlogg" icon={ScrollText}
        subtitle="Alla viktiga beslut registreras med användare, beslut och tidpunkt: schemaändringar, godkännanden, klassificeringar, import, integrationer m.m." />
      {(data || []).length === 0 ? <EmptyState icon={ScrollText} title="Tom logg" text="Åtgärder registreras automatiskt." /> : (
        <Card className="divide-y">
          {data.map((e) => (
            <div key={e.id} className="flex flex-wrap items-center gap-3 px-4 py-3 text-sm" data-testid={`audit-${e.id}`}>
              <span className="font-mono text-xs text-muted-foreground">{fDateTime(e.timestamp)}</span>
              <Badge variant="outline" className="font-mono">{e.action}</Badge>
              <span className="text-muted-foreground">{e.entity_type}{e.entity_id ? ` · ${String(e.entity_id).slice(0, 8)}` : ""}</span>
              <span className="ml-auto flex items-center gap-2 text-xs">
                <span className="font-medium">{e.actor_email}</span>
                <Badge variant="secondary">{e.actor_role}</Badge>
              </span>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
